module.exports = __webpack_public_path__ + "img/bowling.409baef0.gif";